import { PermissionsScreen } from '@/features/setup/screens';
export default PermissionsScreen;
